<div class="d-flex flex-column align-items-center">
    <app-statistics-actions (selectedDepartementEvent)="onSelectDepartement($event)"></app-statistics-actions>
    <app-statistics-image [selectedDepartement]="currentDepartement"></app-statistics-image>
</div>

